var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lite-design-list" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ]
        },
        [_vm._v(_vm._s(_vm.update))]
      ),
      _vm._v(" "),
      _vm._l(_vm.designList, function(design, designID, index) {
        return _c(
          "div",
          {
            staticClass: "lite-design-card",
            on: {
              click: function($event) {
                return _vm.selectDesign(designID)
              },
              dblclick: function($event) {
                return _vm.openDesign(designID)
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "lite-design-card-text",
                class: { "lite-active-design": designID === _vm.idActiveDesign }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(design.designName) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c("img", {
              staticClass: "lite-design-card-img",
              attrs: { src: _vm.getDesignPhoto(designID) },
              on: {
                error: function($event) {
                  return _vm.imageLoadError(designID)
                }
              }
            })
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }